/* eslint import/prefer-default-export: 0 */

export const THEME = {
  DEFAULT: 'default',
  SMALL: 'small'
};
